import React from 'react';

const PaymentCharts = ({ paymentCollection, outstandingReceivables }) => {
    if (!paymentCollection && !outstandingReceivables) return null;

    const totalCollected = paymentCollection?.total_collected ?? 0;
    const totalOutstanding = outstandingReceivables?.total_outstanding ?? 0;
    const outstandingByLocation = outstandingReceivables?.by_location ?? [];

    return (
        <div className="mb-4">
            <h5 className="mb-3 border-bottom pb-2">Payments & Collections</h5>
            <div className="row g-3">
                <div className="col-12">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <div className="card shadow-sm h-100 border-0">
                                <div className="card-body text-center">
                                    <div className="text-muted text-uppercase" style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                                        Total Collected
                                    </div>
                                    <div className="display-6 fw-bold text-success my-2">
                                        {totalCollected.toLocaleString(undefined, { minimumFractionDigits: 3 })}
                                    </div>
                                    <small className="text-muted">KWD this month</small>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card shadow-sm h-100 border-0">
                                <div className="card-body text-center">
                                    <div className="text-muted text-uppercase" style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                                        Outstanding Receivables
                                    </div>
                                    <div className="display-6 fw-bold text-danger my-2">
                                        {totalOutstanding.toLocaleString(undefined, { minimumFractionDigits: 3 })}
                                    </div>
                                    <small className="text-muted">KWD</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {outstandingByLocation.length > 0 && (
                    <div className="col-12">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Outstanding by Location</h6>
                                <div className="table-responsive">
                                    <table className="table table-sm">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Location</th>
                                                <th className="text-end">Outstanding (KWD)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {outstandingByLocation.map((loc, i) => (
                                                <tr key={loc.location_id || i}>
                                                    <td>{loc.location_name || 'Unknown'}</td>
                                                    <td className="text-end">{loc.balance?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PaymentCharts;
